/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Turn_OffInputs */

const en_settings_turn_off = /** @type {(inputs: Settings_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off`)
};

const he_settings_turn_off = /** @type {(inputs: Settings_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כבה`)
};

/**
* | output |
* | --- |
* | "Turn off" |
*
* @param {Settings_Turn_OffInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_turn_off = /** @type {((inputs?: Settings_Turn_OffInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Turn_OffInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_turn_off(inputs)
	return he_settings_turn_off(inputs)
});